/* Homepage VoucherDialog behavior; /tiers keeps its native wallet controls. */
(() => {
	const root = document.querySelector("[data-v3]");
	if (!root || root.dataset.ypVoucherBound === "true") return;
	root.dataset.ypVoucherBound = "true";
	const analytics = window.YPAnalytics;
	const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
	let active = null;
	const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

	const open = (trigger) => {
		if (active || trigger.disabled) return;
		const key = trigger.dataset.ypVoucher;
		const template = [...document.querySelectorAll("template[data-yp-voucher-template]")]
			.find((item) => item.dataset.ypVoucherTemplate === key);
		if (!template) return;
		const scrim = template.content.firstElementChild?.cloneNode(true);
		const dialog = scrim?.querySelector(".v4-voucher");
		const button = dialog?.querySelector("[data-yp-voucher-submit]");
		const error = dialog?.querySelector("[data-yp-voucher-error]");
		const radios = [...(dialog?.querySelectorAll(".v4-dur-input") || [])];
		if (!dialog || !button || !error || !radios.length) return;
		const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : trigger;
		const body = document.body;
		const scrollY = window.scrollY;
		const bodyStyles = Object.fromEntries(["position", "top", "left", "right", "width", "overflow"]
			.map((key) => [key, {value: body.style.getPropertyValue(key), priority: body.style.getPropertyPriority(key)}]));
		const originalButton = button.innerHTML;
		let closing = false;
		let pending = false;
		let closeTimer;
		const isAvailable = (radio) => radio.dataset.ypAvailable === "true" && !radio.disabled && Boolean(radio.dataset.ypCheckoutUrl);
		const initial = radios.find((radio) => radio.dataset.ypTerm === trigger.dataset.ypInitialTerm && isAvailable(radio))
			|| radios.find(isAvailable) || radios[0];
		const initialSku = analytics?.checkoutSku(initial.dataset.ypCheckoutUrl);
		if (initialSku) {
			const tier = initialSku.tier.toLowerCase();
			let label = `v4_buy_${tier}`;
			if (root.dataset.ypPage === 'about') {
				const source = trigger.dataset.ypAnalyticsSource || (trigger.closest('.about-hero') ? 'hero' : trigger.closest('.about-live') ? 'live' : 'rail');
				label = `about_${source}_get_basic`;
			} else if (root.dataset.ypPage === 'long-plans') label = `long_plans_buy_${tier}`;
			else if (initialSku.country !== 'AE') label = `market_buy_${initialSku.country.toLowerCase()}_standard_${initialSku.duration.toLowerCase()}`;
			analytics.trackButtonClick(label);
			analytics.trackDialogOpen(initialSku);
		}
		const update = () => {
			const selected = radios.find((radio) => radio.checked);
			radios.forEach((radio) => {
				if (radio.checked) radio.closest(".v4-dur").dataset.selected = "true";
				else delete radio.closest(".v4-dur").dataset.selected;
			});
			button.disabled = pending || !selected || !isAvailable(selected);
			if (!pending) {
				button.innerHTML = originalButton;
				button.querySelector("[data-yp-button-label]").textContent = selected && isAvailable(selected)
					? template.dataset.ypContinue : selected?.dataset.ypStockStatus === "sold"
						? template.dataset.ypSold : template.dataset.ypUnavailable;
			}
		};
		const cleanup = () => {
			clearTimeout(closeTimer);
			document.removeEventListener("keydown", onKeyDown);
			scrim.remove();
			for (const [key, {value, priority}] of Object.entries(bodyStyles)) {
				if (value) body.style.setProperty(key, value, priority);
				else body.style.removeProperty(key);
			}
			window.scrollTo(0, scrollY);
			if (previousFocus.isConnected) previousFocus.focus({preventScroll: true});
			active = null;
		};
		const requestClose = () => {
			if (closing) return;
			closing = true;
			scrim.dataset.closing = "true";
			dialog.dataset.closing = "true";
			closeTimer = window.setTimeout(cleanup, reduced.matches ? 0 : 240);
		};
		function onKeyDown(event) {
			if (event.key === "Escape") {
				event.preventDefault();
				requestClose();
				return;
			}
			if (event.key !== "Tab") return;
			const focusable = [...dialog.querySelectorAll(focusableSelector)];
			if (!focusable.length) { event.preventDefault(); dialog.focus(); return; }
			const first = focusable[0];
			const last = focusable[focusable.length - 1];
			const focused = document.activeElement;
			if (!dialog.contains(focused) || focused === dialog) {
				event.preventDefault();
				(event.shiftKey ? last : first).focus();
			} else if (event.shiftKey && focused === first) {
				event.preventDefault(); last.focus();
			} else if (!event.shiftKey && focused === last) {
				event.preventDefault(); first.focus();
			}
		}
		radios.forEach((radio) => {
			radio.checked = radio === initial;
			radio.addEventListener("change", () => { error.hidden = true; update(); });
		});
		button.addEventListener("click", () => {
			const selected = radios.find((radio) => radio.checked);
			if (pending || closing || !selected || !isAvailable(selected)) return;
			try {
				const url = new URL(selected.dataset.ypCheckoutUrl, window.location.origin);
				const expectedTail = `/cart/${selected.dataset.ypVariant}:1`;
				if (url.origin !== window.location.origin || !url.pathname.endsWith(expectedTail)
					|| !url.searchParams.has("checkout")) throw new Error("Invalid checkout destination");
				pending = true;
				error.hidden = true;
				button.disabled = true;
				button.dataset.loading = "true";
				button.setAttribute("aria-busy", "true");
				button.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" style="display:block;animation:yp-spin 0.8s linear infinite" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="56.55" stroke-dashoffset="40" opacity="0.9"></circle></svg>';
				const sku = analytics?.checkoutSku(url.href);
				if (sku) {
					analytics.trackButtonClick(sku.country === 'AE'
						? `v4_checkout_${sku.tier.toLowerCase()}_${sku.duration.toLowerCase()}`
						: `market_checkout_${sku.country.toLowerCase()}_standard_${sku.duration.toLowerCase()}`);
					analytics.trackCheckoutStart(sku);
				}
				window.location.assign(analytics?.decorateCheckoutURL(url.href) || url.href);
			} catch {
				// Only this synchronous local failure is observable; checkout's
				// subsequent page/network/payment outcome is not inferred here.
				analytics?.trackCheckoutError(analytics.checkoutSku(selected.dataset.ypCheckoutUrl));
				pending = false;
				delete button.dataset.loading;
				button.removeAttribute("aria-busy");
				error.textContent = template.dataset.ypError;
				error.hidden = false;
				update();
			}
		});
		dialog.querySelector(".v4-voucher-close")?.addEventListener("click", requestClose);
		scrim.addEventListener("click", (event) => { if (event.target === scrim) requestClose(); });
		active = {cleanup};
		root.append(scrim);
		Object.assign(body.style, {position: "fixed", top: `-${scrollY}px`, left: "0", right: "0", width: "100%", overflow: "hidden"});
		document.addEventListener("keydown", onKeyDown);
		update();
		dialog.focus();
	};
	root.addEventListener("click", (event) => {
		const trigger = event.target instanceof Element ? event.target.closest("[data-yp-voucher]") : null;
		if (trigger && root.contains(trigger)) { event.preventDefault(); open(trigger); }
	});
	// A browser Back navigation restores the complete document from bfcache.
	// Clear its pending state so the homepage remains purchasable after checkout.
	window.addEventListener("pageshow", (event) => { if (event.persisted) active?.cleanup(); });
})();
